
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    getClusterStats: ({state, getters, commit, dispatch}, force: boolean) => {

        if (force) state.clusterStatsExpire = null;

        if (state.clusterStatsExpire && moment().isBefore(state.clusterStatsExpire)) {
            return true;
        }

        const chartName = 'clusterStats';

        return new Promise((resolve, reject) => {

            axios.get('/dashboard/es/cluster/stats')

                .then(({data}) => {

                    commit('setClusterStats', {data: data.data, chartName: chartName});
                    resolve(null);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

};
